import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../../components/layout/MainLayout";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import axios from "axios";
import { useHistory, useLocation } from "react-router-dom";
import HistoryChatDisplay from "../../components/history/HistoryChatDisplay";
import botImg from "../../app/assets/videos/Loading-gif.gif";
import "./HistoryPage.scss";
import { useMediaQuery } from "react-responsive";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Login from "../../app/auth/Login";

/* ---------------- Drawer Header ---------------- */
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

/* ---------------- Query Helper ---------------- */
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

/* ---------------- History Page ---------------- */
const HistoryPage = () => {
  const [responceData, setresponceData] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [dataError, setDataError] = useState(false);

  const query = useQuery();
  const id = query.get("id");

  const isTab = useMediaQuery({ query: "(max-width: 768px)" });
  const history = useHistory();

  /* ---------------- Fetch History Item ---------------- */
  const fetchHistoryDataItem = useCallback(async () => {
    if (!id) return;

    setDataError(false);
    setDataLoading(true);

    const baseUrl = `${process.env.REACT_APP_BASE_URL}/aadi/history2.0/data2.0/response/${id}`;

    try {
      const response = await axios.get(baseUrl);

      if (response.status === 200) {
        setresponceData(response.data);
        setDataLoading(false);
      } else {
        setDataLoading(false);
        setDataError(true);
      }
    } catch (error) {
      setDataLoading(false);
      setDataError(true);
      console.error("Error fetching history data:", error);
    }
  }, [id]);

  /* ---------------- IMPORTANT FIX ---------------- */
  useEffect(() => {
    fetchHistoryDataItem();
  }, [fetchHistoryDataItem]);

  /* ---------------- New Chat ---------------- */
  const newChatStart = useCallback(() => {
    history.push("/");
  }, [history]);

  /* ---------------- UI ---------------- */
  return (
    <>
      <AuthenticatedTemplate>
        <div id="homePage">
          <Box
            className="mainLayout"
            sx={{
              display: "flex",
              flexDirection: isTab ? "column" : "row",
              overflowWrap: isTab ? "break-word" : "normal",
            }}
          >
            <MainLayout newChatStart={newChatStart} />

            <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
              <DrawerHeader />
              <DrawerHeader style={{ minHeight: "0px", paddingTop: "3px" }} />

              <div id="mainHistory">
                {!dataLoading && !dataError && (
                  <HistoryChatDisplay
                    responceData={responceData}
                    newChatStart={newChatStart}
                  />
                )}

                {dataLoading && (
                  <div className="loading-cont">
                    <img width={120} src={botImg} alt="aadi-loading" />
                    <p>Fetching History ...</p>
                  </div>
                )}

                {!dataLoading && dataError && (
                  <div className="loading-cont">
                    <p>
                      Something Went Wrong.{" "}
                      <span
                        onClick={() => window.location.reload()}
                        className="try-again-btn"
                      >
                        Please try again.
                      </span>
                    </p>
                  </div>
                )}
              </div>
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

export default HistoryPage;
